import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

export default function CustomizedDialogs(props) {
  const [open, setOpen] = React.useState(false);
  const [testTypeLabel, setTestTypeLabel] = React.useState("Test");
  const [submitTestLoading, setSubmitTestLoading] = React.useState(false);
  const [stopTestLoading, setStopTestLoading] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  
  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
		setSubmitTestLoading(false);
    setStopTestLoading(false);
    if(open && props.testType==1){
      setTestTypeLabel("Session");
    }else{
      setTestTypeLabel("Test");
    }
	}, [open,props.testType]);

  function submitTest(){
      setSubmitTestLoading(true);
      props.toCallParentMethod();      
  }

  function stopTestNow(){  
      setStopTestLoading(true);  
      props.toCallParentStopTestNow();      
  }
  // function backToSelectTest(){
  //   if(props.testType==1){
	// 	  window.location.href='selfassessor';
  //   }else if(props.testType==2){
	// 	  window.location.href='selecttopictest';
  //   }else if(props.testType==4){
	// 	  window.location.href='selectclasstest';    
  //   }else{
  //     window.location.href='selectmocktest';
  //   }  
	// }

  return (
    <>
      <Button title={"Save "+testTypeLabel+" & Exit"} onClick={handleClickOpen} variant="contained" color="primary" >Save & Exit</Button>
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle onClose={handleClose}>
          {!window.navigator.onLine?<span style={{color:'#FF0000'}}>Alert</span>:<>Save & Exit</>} 
        </DialogTitle>

        <DialogContent dividers>
            <div className="dialogSubmitTestBox">
              {!window.navigator.onLine?
              <p style={{color:'#FF0000',fontWeight:'bold',minHeight:60, padding: 20}}>
                It seems, you are not connected to the internet.
              </p>
              :
              <>
              <p>
                Click on Submit {testTypeLabel} Now for submitting your {testTypeLabel} for result.<br/> 
                Click on Stop {testTypeLabel} & Continue Later in case you want to stop your {testTypeLabel} you can continue it later.  
                <br/><br/>               
              </p>
              {submitTestLoading?
                <LoadingButton loading={submitTestLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{backgroundColor:'#008000',color:'#FFFFFF'}}  variant="contained" >Wait</LoadingButton>
                :!stopTestLoading?<Button onClick={() => { submitTest() }} variant="contained" style={{backgroundColor:'#008000',color:'#FFFFFF'}} >Submit {testTypeLabel} Now</Button>
                :null
              }

              {(props.testType!=4 && props.testType!=5)?<>
                {stopTestLoading?
                  <LoadingButton loading={stopTestLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{backgroundColor:'#ff1919',color:'#FFFFFF'}} variant="contained" >Wait</LoadingButton>
                :!submitTestLoading?<Button onClick={() => { stopTestNow() }} variant="contained" color="secondary" >Stop {testTypeLabel} & Continue Later</Button>
                :null
                }
              </>:null}              
              {/* <Button onClick={() => { backToSelectTest() }} style={{marginRight:20}} size="small" variant="outlined" >Cancel Test</Button> */}
              </>
              }
            </div>
        </DialogContent>

      </Dialog>
    </>
  );
}
